import {buildSchema} from "@camberi/firecms";

const adminSchema = buildSchema({
    name: "admins",
    properties: {
        name: {
            dataType: "string",
            title: "Name",
            // disabled: true,
            validation: {
                required: true,
            
            }
        },
        email: {
            dataType: "string",
            title: "Email",
            columnWidth: 1000,
            validation: {
                required: true
            }
        },
    }
});

adminSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default adminSchema;
